module.exports = __webpack_public_path__ + "media/images/flags/16/Central-African-Republic-fe9230348a4f5348dc1b844759fee2b4.png";